/**
 * Trigger a PDF download from POST endpoint with optional body.
 */
import { api, BACKEND_URL } from "../lib/api";

export async function downloadPDF(endpoint, body = {}, filename = "reporte.pdf") {
  const token = localStorage.getItem("token");
  const audit = localStorage.getItem("audit_tenant_id");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  if (audit) headers["X-Audit-Tenant-Id"] = audit;
  const res = await fetch(`${BACKEND_URL}/api${endpoint}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const txt = await res.text();
    alert("Error generando PDF: " + txt);
    return;
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export { api };
